import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {AssetLoaderEvent} from "@nolimitcity/slot-game/bin/core/resource/asset/AssetLoaderEvent";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TextureHelper} from "../helper/TextureHelper";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";

/**
 * Created by Jerker Nord on 2020-08-05.
 */

export class MonkeysGoldResourceCreateController {

    private static SYMBOL_NAMES:string[] = ["L1", "L2", "L3", "L4", "L5", "M1", "M2", "M3", "M4", "M5"];

    constructor() {
        this.addEventHandlers();
    }

    private addEventHandlers():void {
        EventHandler.addFirstEventListener(this, AssetLoaderEvent.ALL_LEVELS_COMPLETE, (event:AssetLoaderEvent) => this.onLevelComplete(event));
    }

    private onLevelComplete(event:AssetLoaderEvent):void {
        if(event.name == "intro") {
            this.createSymbolTextures();
            this.createWinSymbolAttentionAnimation();
            this.createInitialWinAnimation();
        }
    }

    private getFrameName(baseName:string, count:number):string {
        const countLength:number = count.toString().length;
        return baseName.substr(0, baseName.length - countLength) + count.toString();
    }

    private createInitialWinAnimation():void {
        const container:PIXI.Container = new PIXI.Container();
        for(let i:number = 0; i < 21; i++) {
            container.removeChildren();
            let frameTexture:PIXI.Texture = GameResources.getTextures(this.getFrameName("initial win/3x3_pink_win/3x3_pink_win_00000", i))[0];
            const frameSprite:PIXI.Sprite = new PIXI.Sprite(frameTexture);
            frameSprite.scale.set(186 / 560, 158 / 460);
            container.addChild(frameSprite);
            const texture1x1:PIXI.Texture = TextureHelper.createRenderedTextureFromContainer(container);
            this.updateTextureCache(texture1x1, this.getFrameName("initial win/1x1_pink_win/Pre-comp 11_00000", i));
            frameSprite.scale.set(377 / 560, 319 / 460);
            const texture2x2:PIXI.Texture = TextureHelper.createRenderedTextureFromContainer(container);
            this.updateTextureCache(texture1x1, this.getFrameName("initial win/2x2_pink_win/Pre-comp 11_00000", i));
        }
    }

    private createWinSymbolAttentionAnimation():void {
        const container:PIXI.Container = new PIXI.Container();
        for(let i:number = 0; i < 35; i++) {
            container.removeChildren();
            let frameTexture:PIXI.Texture = GameResources.getTextures(this.getFrameName("winFrame/3x3/win_3x3_00000", i))[0];
            const frameSprite:PIXI.Sprite = new PIXI.Sprite(frameTexture);
            frameSprite.scale.set(200 / 600, 200 / 600);
            container.addChild(frameSprite);
            frameSprite.position.set(50, 50);
            const texture1x1:PIXI.Texture = TextureHelper.createRenderedTextureFromContainer(container,1 , 100, 100);
            this.updateTextureCache(texture1x1, this.getFrameName("winFrame/1x1/win_1x1_00000", i));
            frameSprite.scale.set(400 / 600, 400 / 600);
            frameSprite.position.set(0, 0);
            const texture2x2:PIXI.Texture = TextureHelper.createRenderedTextureFromContainer(container);
            this.updateTextureCache(texture2x2, this.getFrameName("winFrame/2x2/win_2x2_00000", i));
        }
    }

    private createSymbolTextures():void {
        const container:PIXI.Container = new PIXI.Container();

        for(let i:number = 0; i < MonkeysGoldResourceCreateController.SYMBOL_NAMES.length; i++) {
            container.removeChildren();
            let x3Texture:PIXI.Texture = GameResources.getTextures(MonkeysGoldResourceCreateController.SYMBOL_NAMES[i] + "_colossalx3/" + MonkeysGoldResourceCreateController.SYMBOL_NAMES[i] + "_colossalx3")[0];
            const x3Sprite:PIXI.Sprite = new PIXI.Sprite(x3Texture);
            x3Sprite.scale.set(120 / 360, 120 / 360);
            container.addChild(x3Sprite);
            const texture1x1:PIXI.Texture = TextureHelper.createRenderedTextureFromContainer(container);
            this.updateTextureCache(texture1x1, MonkeysGoldResourceCreateController.SYMBOL_NAMES[i] + "/" + MonkeysGoldResourceCreateController.SYMBOL_NAMES[i]);

            x3Sprite.scale.set(240 / 360, 240 / 360);
            const texture2x2:PIXI.Texture = TextureHelper.createRenderedTextureFromContainer(container);
            this.updateTextureCache(texture2x2, MonkeysGoldResourceCreateController.SYMBOL_NAMES[i] + "_colossalx2/" + MonkeysGoldResourceCreateController.SYMBOL_NAMES[i] + "_colossalx2");

            container.removeChildren();
            let x3SpinTexture:PIXI.Texture = GameResources.getTextures(MonkeysGoldResourceCreateController.SYMBOL_NAMES[i] + "_colossalx3/" + MonkeysGoldResourceCreateController.SYMBOL_NAMES[i] + "_colossalx3_spin")[0];
            const spinX3Sprite:PIXI.Sprite = new PIXI.Sprite(x3SpinTexture);
            spinX3Sprite.scale.set(120 / 360, 120 / 360);
            container.addChild(spinX3Sprite);
            const blurredTexture1x1:PIXI.Texture = TextureHelper.createRenderedTextureFromContainer(container);
            this.updateTextureCache(blurredTexture1x1, MonkeysGoldResourceCreateController.SYMBOL_NAMES[i] + "/" + MonkeysGoldResourceCreateController.SYMBOL_NAMES[i] + "_spin");

            spinX3Sprite.scale.set(240 / 360, 240 / 360);
            const blurredTexture2x2:PIXI.Texture = TextureHelper.createRenderedTextureFromContainer(container);
            this.updateTextureCache(blurredTexture2x2, MonkeysGoldResourceCreateController.SYMBOL_NAMES[i] + "_colossalx2/" + MonkeysGoldResourceCreateController.SYMBOL_NAMES[i] + "_colossalx2_spin");
        }
    }

    private updateTextureCache(texture:PIXI.Texture, id:string):void {
        if(PIXI.utils.TextureCache[id]) {
            PIXI.Texture.removeFromCache(id);
            PIXI.Texture.addToCache(texture, id);
        } else {
            PIXI.Texture.addToCache(texture, id);
        }
    }
}